<template>
  <div class="users">
    <div class="users__header">
      <h1 class="users__title">Editer {{ title }}</h1>
      <button
        class="button button--invalid button--x-small"
        @click="deleteUser(user)"
      >
        SUPPRIMER
      </button>
    </div>

    <form @submit.prevent="editUser" class="user-form">
      <div class="form-row">
        <label for="input-firstname">Prénom</label>
        <input
          type="text"
          class="input"
          id="input-firstname"
          placeholder="Prénom"
          v-model="user.firstname"
        />
      </div>
      <div class="form-row">
        <label for="input-lastname">Nom</label>
        <input
          type="text"
          class="input"
          id="input-lastname"
          placeholder="Nom"
          v-model="user.lastname"
        />
      </div>
      <div class="form-row">
        <label for="input-email">Email</label>
        <input
          type="email"
          class="input"
          id="input-email"
          placeholder="Email"
          v-model="user.email"
        />
      </div>
      <button class="button user-form__cta" type="submit">
        MODIFIER
      </button>
    </form>
  </div>
</template>

<script>
import { api } from '@/lib/api';

export default {
  data() {
    return {
      user: {},
    };
  },
  async created() {
    const { data: user } = await api.get(`/users/${this.$route.params.id}`);

    this.user = user;
    this.title = `${user.firstname} ${user.lastname}`;
  },
  methods: {
    async deleteUser(user) {
      if (confirm('Êtes vous sûr de vouloir de supprimer cet utilisateur ?')) {
        if (user.site) {
          await api.delete(user.site);
        }

        await api.delete(`/users/${user.id}`);

        this.$router.push({ name: 'UsersList' });
      }
    },
    async editUser() {
      await api.put(`/users/${this.user.id}`, this.user);

      this.$router.push({ name: 'UsersList' });
    },
  },
};
</script>
